'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var dagPb = require('@ipld/dag-pb');

var cbor = require('cborg');

var pinSet = require('./pin-set.js');

var utils = require('./utils.js');

var length = require('it-length');

var sha2 = require('multiformats/hashes/sha2');

var mhd = require('multiformats/hashes/digest');

var base32 = require('multiformats/bases/base32');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var dagPb__namespace = /*#__PURE__*/_interopNamespace(dagPb);

var cbor__namespace = /*#__PURE__*/_interopNamespace(cbor);

var length__default = /*#__PURE__*/_interopDefaultLegacy(length);

var mhd__namespace = /*#__PURE__*/_interopNamespace(mhd);

function pinsToDatastore(_x, _x2, _x3, _x4) {
  return _pinsToDatastore.apply(this, arguments);
}

function _pinsToDatastore() {
  _pinsToDatastore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blockstore, datastore, pinstore, onProgress) {
    var mh, cid$1, pinRootBuf, pinRoot, counter, pinCount, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _cid, pin, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _cid2, _pin;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return datastore.has(utils.PIN_DS_KEY);

          case 2:
            if (_context.sent) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            _context.next = 6;
            return datastore.get(utils.PIN_DS_KEY);

          case 6:
            mh = _context.sent;
            cid$1 = cid.CID.decode(mh);
            _context.next = 10;
            return blockstore.get(cid$1);

          case 10:
            pinRootBuf = _context.sent;
            pinRoot = dagPb__namespace.decode(pinRootBuf);
            counter = 0;
            _context.next = 15;
            return length__default['default'](pinSet.loadSet(blockstore, pinRoot, utils.PinTypes.recursive));

          case 15:
            _context.t0 = _context.sent;
            _context.next = 18;
            return length__default['default'](pinSet.loadSet(blockstore, pinRoot, utils.PinTypes.direct));

          case 18:
            _context.t1 = _context.sent;
            pinCount = _context.t0 + _context.t1;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 22;
            _iterator = _asyncIterator(pinSet.loadSet(blockstore, pinRoot, utils.PinTypes.recursive));

          case 24:
            _context.next = 26;
            return _iterator.next();

          case 26:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 38;
              break;
            }

            _cid = _step.value;
            counter++;
            pin = {
              depth: Infinity
            };

            if (_cid.version !== 0) {
              pin.version = _cid.version;
            }

            if (_cid.code !== dagPb__namespace.code) {
              pin.codec = _cid.code;
            }

            _context.next = 34;
            return pinstore.put(utils.cidToKey(_cid), cbor__namespace.encode(pin));

          case 34:
            onProgress(counter / pinCount * 100, "Migrated recursive pin ".concat(_cid));

          case 35:
            _iteratorAbruptCompletion = false;
            _context.next = 24;
            break;

          case 38:
            _context.next = 44;
            break;

          case 40:
            _context.prev = 40;
            _context.t2 = _context["catch"](22);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 44:
            _context.prev = 44;
            _context.prev = 45;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 49;
              break;
            }

            _context.next = 49;
            return _iterator.return();

          case 49:
            _context.prev = 49;

            if (!_didIteratorError) {
              _context.next = 52;
              break;
            }

            throw _iteratorError;

          case 52:
            return _context.finish(49);

          case 53:
            return _context.finish(44);

          case 54:
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context.prev = 56;
            _iterator2 = _asyncIterator(pinSet.loadSet(blockstore, pinRoot, utils.PinTypes.direct));

          case 58:
            _context.next = 60;
            return _iterator2.next();

          case 60:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context.sent).done)) {
              _context.next = 72;
              break;
            }

            _cid2 = _step2.value;
            counter++;
            _pin = {
              depth: 0
            };

            if (_cid2.version !== 0) {
              _pin.version = _cid2.version;
            }

            if (_cid2.code !== dagPb__namespace.code) {
              _pin.codec = _cid2.code;
            }

            _context.next = 68;
            return pinstore.put(utils.cidToKey(_cid2), cbor__namespace.encode(_pin));

          case 68:
            onProgress(counter / pinCount * 100, "Migrated direct pin ".concat(_cid2));

          case 69:
            _iteratorAbruptCompletion2 = false;
            _context.next = 58;
            break;

          case 72:
            _context.next = 78;
            break;

          case 74:
            _context.prev = 74;
            _context.t3 = _context["catch"](56);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t3;

          case 78:
            _context.prev = 78;
            _context.prev = 79;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context.next = 83;
              break;
            }

            _context.next = 83;
            return _iterator2.return();

          case 83:
            _context.prev = 83;

            if (!_didIteratorError2) {
              _context.next = 86;
              break;
            }

            throw _iteratorError2;

          case 86:
            return _context.finish(83);

          case 87:
            return _context.finish(78);

          case 88:
            _context.next = 90;
            return blockstore.delete(cid$1);

          case 90:
            _context.next = 92;
            return datastore.delete(utils.PIN_DS_KEY);

          case 92:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[22, 40, 44, 54], [45,, 49, 53], [56, 74, 78, 88], [79,, 83, 87]]);
  }));
  return _pinsToDatastore.apply(this, arguments);
}

function pinsToDAG(_x5, _x6, _x7, _x8) {
  return _pinsToDAG.apply(this, arguments);
}

function _pinsToDAG() {
  _pinsToDAG = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(blockstore, datastore, pinstore, onProgress) {
    var recursivePins, directPins, counter, pinCount, _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _step3$value, key, value, pin, _cid$, pinRoot, buf, digest, cid$1;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            recursivePins = [];
            directPins = [];
            counter = 0;
            _context2.next = 5;
            return length__default['default'](pinstore.queryKeys({}));

          case 5:
            pinCount = _context2.sent;
            _iteratorAbruptCompletion3 = false;
            _didIteratorError3 = false;
            _context2.prev = 8;
            _iterator3 = _asyncIterator(pinstore.query({}));

          case 10:
            _context2.next = 12;
            return _iterator3.next();

          case 12:
            if (!(_iteratorAbruptCompletion3 = !(_step3 = _context2.sent).done)) {
              _context2.next = 21;
              break;
            }

            _step3$value = _step3.value, key = _step3$value.key, value = _step3$value.value;
            counter++;
            pin = cbor__namespace.decode(value);
            _cid$ = cid.CID.create(pin.version || 0, pin.codec || dagPb__namespace.code, mhd__namespace.decode(base32.base32.decode('b' + key.toString().toLowerCase().split('/').pop())));

            if (pin.depth === 0) {
              onProgress(counter / pinCount * 100, "Reverted direct pin ".concat(_cid$));
              directPins.push(_cid$);
            } else {
              onProgress(counter / pinCount * 100, "Reverted recursive pin ".concat(_cid$));
              recursivePins.push(_cid$);
            }

          case 18:
            _iteratorAbruptCompletion3 = false;
            _context2.next = 10;
            break;

          case 21:
            _context2.next = 27;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](8);
            _didIteratorError3 = true;
            _iteratorError3 = _context2.t0;

          case 27:
            _context2.prev = 27;
            _context2.prev = 28;

            if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
              _context2.next = 32;
              break;
            }

            _context2.next = 32;
            return _iterator3.return();

          case 32:
            _context2.prev = 32;

            if (!_didIteratorError3) {
              _context2.next = 35;
              break;
            }

            throw _iteratorError3;

          case 35:
            return _context2.finish(32);

          case 36:
            return _context2.finish(27);

          case 37:
            onProgress(100, 'Updating pin root');
            _context2.next = 40;
            return pinSet.storeSet(blockstore, utils.PinTypes.direct, directPins);

          case 40:
            _context2.t1 = _context2.sent;
            _context2.next = 43;
            return pinSet.storeSet(blockstore, utils.PinTypes.recursive, recursivePins);

          case 43:
            _context2.t2 = _context2.sent;
            _context2.t3 = [_context2.t1, _context2.t2];
            pinRoot = {
              Links: _context2.t3
            };
            buf = dagPb__namespace.encode(pinRoot);
            _context2.next = 49;
            return sha2.sha256.digest(buf);

          case 49:
            digest = _context2.sent;
            cid$1 = cid.CID.createV0(digest);
            _context2.next = 53;
            return blockstore.put(cid$1, buf);

          case 53:
            _context2.next = 55;
            return datastore.put(utils.PIN_DS_KEY, cid$1.bytes);

          case 55:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 23, 27, 37], [28,, 32, 36]]);
  }));
  return _pinsToDAG.apply(this, arguments);
}

function process(_x9, _x10, _x11) {
  return _process.apply(this, arguments);
}

function _process() {
  _process = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(backends, onProgress, fn) {
    var blockstore, datastore, pinstore;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            blockstore = backends.blocks;
            datastore = backends.datastore;
            pinstore = backends.pins;
            _context3.next = 5;
            return blockstore.open();

          case 5:
            _context3.next = 7;
            return datastore.open();

          case 7:
            _context3.next = 9;
            return pinstore.open();

          case 9:
            _context3.prev = 9;
            _context3.next = 12;
            return fn(blockstore, datastore, pinstore, onProgress);

          case 12:
            _context3.prev = 12;
            _context3.next = 15;
            return pinstore.close();

          case 15:
            _context3.next = 17;
            return datastore.close();

          case 17:
            _context3.next = 19;
            return blockstore.close();

          case 19:
            return _context3.finish(12);

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[9,, 12, 20]]);
  }));
  return _process.apply(this, arguments);
}

var migration = {
  version: 9,
  description: 'Migrates pins to datastore',
  migrate: function migrate(backends) {
    var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return process(backends, onProgress, pinsToDatastore);
  },
  revert: function revert(backends) {
    var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return process(backends, onProgress, pinsToDAG);
  }
};
exports.migration = migration;